'use client';

import { FC, useContext } from 'react';
import { OtherSignaturesProps } from './OtherSignatures.types';
import { UserContext } from '@/_contexts/UserProvider';
import { EngagementSignature } from '@/_types/models/questionnaire';
import { Flex, Icon, Text } from '@/_components';
import { PREDEFINED_MARKED_NOT_NEEDED } from '@/_constants/questions';
import { FirmSettingsContext } from '@/_contexts/FirmSettingsProvider';

export const OtherSignatures: FC<OtherSignaturesProps> = ({
  mode,
  signatures,
}) => {
  const { user, isAdvisor } = useContext(UserContext);
  const { preferences } = useContext(FirmSettingsContext);

  const filteredSignatures: Array<EngagementSignature> = signatures?.filter(
    (s) => s.user_id !== user?.id,
  );

  if (!filteredSignatures?.length) return null;

  const _generateSignature = (name: string): string => {
    return `'${name.endsWith('s') ? '' : 's'} signature was marked not needed.`;
  };

  return (
    <Flex isColumn={true} gap={4}>
      {filteredSignatures?.map((signature, key) => {
        const isSigned: boolean = !!signature?.signed_at;
        const signedCopy: string = isSigned
          ? signature?.signature === PREDEFINED_MARKED_NOT_NEEDED
            ? _generateSignature(signature.user_name)
            : mode === 'admin-template'
              ? ' will sign here.'
              : ' has already signed.'
          : isAdvisor
            ? ' has not signed yet.'
            : preferences.require_one_signature_per_section
              ? ''
              : ' is also required to sign. If unavailable or email needs to be updated, please send us a message.';

        return (
          <Flex gap={4} key={key} isYCentered={true}>
            <Icon
              name={isSigned ? 'check-circle' : 'nib'}
              size={20}
              color="secondary"
            />
            <Text type="tiny" color="secondary">
              <b>{signature.user_name}</b>
              {signedCopy}
            </Text>
          </Flex>
        );
      })}
    </Flex>
  );
};
